import ConfirmSaleModal from './ConfirmSaleModal';

export default ConfirmSaleModal;
